export default "__VITE_ASSET__LY7YnS4I__"